module.exports = __webpack_public_path__ + "static/media/SarahSwitek_12_Activities-List_4.c2e4ee0d.mp3";